import { ProgramSwitcherSelectionsV1NaptimeResource } from './__generated__/ProgramSwitcherSelectionsV1';

class ProgramSwitcherSelections extends ProgramSwitcherSelectionsV1NaptimeResource {
  static RESOURCE_NAME = 'programSwitcherSelections.v1' as const;
}

export default ProgramSwitcherSelections;
